(function($) {
    "use strict";
    function refreshCart(data,single_variation) {
         if (data.item_count > 0) {
                    //$('.widget_shopping_cart .widget_shopping_cart_content').html(data.cart_html);
                    if ($("#cart-"+single_variation.id).length > 0) {
                        $("#cart-"+single_variation.id).find(".quantity").html(single_variation.quantity + 'x' + '<span class="amount"><span class="money">'+Shopify.formatMoney(single_variation.price)+'</span></span>');
                    }else{
                        var html = '';
                        html +='<li id="cart-'+single_variation.id+'">';
                        html +='<a href="'+single_variation.url+'" class="name-thumb">';
                        html +='<img width="240" height="200" src="'+single_variation.image+'" alt="'+single_variation.title+'">'+single_variation.title+'&nbsp;';
                        html +='  </a>';
                        if (single_variation.variant_title != null ) {
                            html +='  <dl class="variation">';
                            html +='    <dt class="variation-Color">Size:';
                            html +='    </dt>';
                            html +='<dd class="variation-Color">';
                            html +='<p>'+single_variation.variant_title;
                            html +='</p>';
                            html +='</dd>';
                            html +='</dl>';
                        }
                        html +='<span class="quantity">'+single_variation.quantity+' × ';
                        html +='<span class="amount money">'+Shopify.formatMoney(single_variation.price);
                        html +='</span>';
                        html +='</span> ';        
                        html +='<a href="/cart/change?line='+single_variation.id+'&amp;quantity=0" data-pid="'+single_variation.id+'" class="remove" title="Remove this item">×';
                        html +='</a>';        
                        html +='</li>';
                        $('.widget_shopping_cart .product_list_widget').append(html);
                        $(".no-item").remove();
                    }
                }
                $('.mini-cart-total-item').text(data.item_count);
                $(".widget_shopping_cart  .total .amount").html('<span class="money">' + Shopify.formatMoney(data.total_price) + '</span>');
                window.location = '#';
                $('#myModal').modal('hide');
                $('body').toggleClass("open-cart");
               	$('.background-overlay').toggleClass("visible");
       			ConvertCurrency();
      			
                 
              		
       
                    
    }
	$('body').on('click',".background-overlay",function(){

      $("#close-cart").trigger('click');
    });
    $(document).ready(function(){
        //Add to cart effect
        $(document).mouseup(function (e) {
            var container = $(".open-cart");

            if (!container.is(e.target) && container.has(e.target).length === 0)
            {
                container.removeClass('opencart');
            }
        });
        $(document).on('click', '#ajax_add_to_cart_single-single.single_add_to_cart_button', function(event) {
            event.preventDefault();
            /* Act on the event */
            var obj = $(this);
            var $id = $("#product-select-single").val();
                    obj.addClass('loading1');
            var $quatity = parseInt($("#quantity-single").val());
            $quatity = (isNaN($quatity) || $quatity < 1 ) ? 1 : $quatity;
            Shopify.addItem($id, $quatity, function(response) {
                Shopify.getCart(function(data) {
                    swal({
                        
                        'text': 'Added success to your cart',
                        showCloseButton: false,
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 2000
                    });
                     obj.removeClass('loading1');
                    refreshCart(data,response);
                    ConvertCurrency();
                })
            });
        });
        $(document).on('click', '#ajax_add_to_cart_single-qv.single_add_to_cart_button', function(event) {
            event.preventDefault();
            /* Act on the event */
            var obj = $(this);
            var $id = $("#product-select-qv").val();
         
                    obj.addClass('loading1');
            var $quatity = parseInt($("#quantity-qv").val());
            $quatity = (isNaN($quatity) || $quatity < 1 ) ? 1 : $quatity;
            Shopify.addItem($id, $quatity, function(response) {
                Shopify.getCart(function(data) {
                    swal({
                        
                        'text': 'Added success to your cart',
                        showCloseButton: false,
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 2000
                    });
                     obj.removeClass('loading1');
                    refreshCart(data,response);
                    ConvertCurrency();

                })
            });
        });
       $(document).on('click', '.product_type_simple', function(event) {
       		
         event.preventDefault();
            /* Act on the event */
            var obj = $(this);
            var $id = $(this).data('pid');
         
                    obj.addClass('loading1');
            var $quatity =1;
            
            Shopify.addItem($id, 1, function(response) {
                Shopify.getCart(function(data) {
                    swal({
                        
                        'text': 'Added success to your cart',
                        showCloseButton: false,
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 2000
                    });
                     obj.removeClass('loading1');
                    refreshCart(data,response);
                    ConvertCurrency();

                })
            });
       });
        $(document).on('click', '.widget_shopping_cart_content .remove ,.shop_table.cart  .remove', function(event) {
            event.preventDefault();
            /* Act on the event */
            var $id = $(this).data('pid');
            Shopify.removeItem($id, function(data) {
                $("#cart-" + $id+',.cart-'+$id).slideUp(500).remove();
                swal({
                    
                    'text': 'Remove success item',
                    showCloseButton: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 2000
                });
                $(".widget_shopping_cart  .total .amount").html('<span class="money">' + Shopify.formatMoney(data.total_price) + '</span>');
                $('.mini-cart-total-item').text(data.item_count);
                ConvertCurrency();
            });
        });
        $(document).on('change', '.listen-change-quantity', function(event) {
            event.preventDefault();
            /* Act on the event */
            var $val = $(this).val();
            var $pid = $(this).data('pid');
            $(".product-quantity").css('pointer-events','none');
            var $price = parseInt($(this).data('origin'));
            $val = (isNaN(parseInt($val)) || $val < 1 ) ? 1 : parseInt($val);
            Shopify.changeItem($pid,$val,function(response){
                $(".widget_shopping_cart  .total .amount,.order-total .amount").html('<span class="money">' + Shopify.formatMoney(response.total_price) + '</span>');
                $('.mini-cart-total-item').text(response.item_count);
                $("#cart-"+$pid).find(".quantity").html($val + 'x' + '<span class="amount"><span class="money">'+Shopify.formatMoney($price*$val)+'</span></span>');
                $(".cart-"+$pid).find(".product-subtotal .amount").html('<span class="money">'+Shopify.formatMoney($price*$val)+'</span>');
                ConvertCurrency();
                $(".product-quantity").css('pointer-events','auto');
            });
        });
        // Scroll top Top
        var windowHeight = $(window).height();
        $(window).scroll(function() {
            if($(this).scrollTop() > windowHeight ) {
                $('.scrollToTop').fadeIn();
            } else {
                $('.scrollToTop').fadeOut();
            }
        });

        $('.scrollToTop').click(function() {
            $('body,html').animate({scrollTop:0},800);
        });

        //Push menu
        $("#menu-toggle").click(function () {
            $('body').addClass('open');
            $('.background-overlay').addClass('visible');
        });
        $("#close-menu").click(function () {
            $('body').removeClass('open');
            $('.background-overlay').removeClass('visible');
        });

        $(document).mouseup(function (e) {
            var container = $("body.open");

            if (!container.is(e.target) && container.has(e.target).length === 0)
            {
                container.removeClass('open');
            }
        });

        //Mini Cart
        $("#cart-toggle").click(function () {
            $('body').addClass('open-cart');
            $('.background-overlay').addClass('visible');
        });
        $("#close-cart").click(function () {
            $('body').removeClass('open-cart');
            $('.background-overlay').removeClass('visible');
        });

        $(document).mouseup(function (e) {
            var container = $("body.open-cart");

            if (!container.is(e.target) && container.has(e.target).length === 0)
            {
                container.removeClass('open-cart');
            }
        });
    });

    //Sticky header
    $(window).scroll(function() {
        if(space_stickey_menu == 1)
        {
            if ($(this).scrollTop() > 2){
                $('header').addClass("sticky");
            }
            else{
                $('header').removeClass("sticky");
            }
        }

    });
} )( jQuery );